const textSeparator = {
    doubleQuote: '"',
    singleQuote: '\'',
    pipe: '|'
};

export default textSeparator;
